import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table, Input, Select, Tooltip } from "antd";
import { Collapse } from "antd";
import { getRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import PropTypes from "prop-types";

export const SPECIFIC_GRAVITY = {
  GI: 7.85,
  MS: 7.85,
  CU: 8.96,
  AL: 2.7,
  SS: 8.0,
};

export function getDensity(material) {
  const sg = SPECIFIC_GRAVITY[material.toUpperCase()] || 0;
  return sg * 1000; 
}

export function getKgPerMeter(widthMM, thicknessMM, material) {
  const density = getDensity(material);
  const widthM = widthMM / 1000;
  const thicknessM = thicknessMM / 1000;
  const lengthM = 1;
  const volume = widthM * thicknessM * lengthM;
  return density * volume;
}

const { Panel } = Collapse;

const ViewNewPR = ({ response, uomList }) => {
  const [siteName, setSiteName] = useState([]);

  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const { t } = useTranslation();
  const { id } = useParams();

  const [res, setRes] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [stateWBS, setStateWBS] = useState([]);

  const [state, setState] = useState([]);
  const [rfqIDD, setRfqIDD] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [apiLoading, setapiLoading] = useState(false);
  const memoizedPincodeList = useMemo(() => uomList || [], [uomList]);
  const getSubCategory = async () => {
    const length = response?.city_wise_pr?.length;
    setCityLength(length);
  };

  useEffect(() => {
    if (response.pr_city_wise_by_pr_number !== null) {
      getSubCategory();
    }
    if (siteName.length === 0) {
      getSiteName();
      setPincodeList(uomList);
    }
  }, []);

  const updateTableData = (state) => {
    setapiLoading(true);
    if (!Array.isArray(state)) {
      return;
    }

    let rfqPresent = null;

    const uniqueMasterIds = new Set();

    state?.forEach((city) => {
      city.city_wise_pr?.forEach((cityDetail) => {
        cityDetail.site_wise_details?.forEach((site) => {
          site.material_wise_details?.forEach((material) => {
            if (material.purchase_requisition_master_id) {
              uniqueMasterIds.add(material.purchase_requisition_master_id);
            }
          });
        });
      });
    });

    const uniqueMasterIdsBySiteAndMaterial = {};
    state?.forEach((city) => {
      city.city_wise_pr?.forEach((cityDetail) => {
        cityDetail.site_wise_details?.forEach((site) => {
          const siteName = site.site_name;
          if (!uniqueMasterIdsBySiteAndMaterial[siteName]) {
            uniqueMasterIdsBySiteAndMaterial[siteName] = {};
          }
          site.material_wise_details?.forEach((material) => {
            const materialTypeName = material.material_type_name;
            if (!uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName]) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName] =
                new Set();
            }
            if (material.purchase_requisition_master_id) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName].add(
                material.purchase_requisition_master_id,
              );
            }
          });
        });
      });
    });

    const tableData = [];
    const length = state[0].city_wise_pr.length;
    setCityLength(length);

    state.forEach((prObject, prIndex) => {
      prObject.city_wise_pr.forEach((city, cityIndex) => {
        console.log("cdddity", city);

        const cityRowSpan = city.site_wise_details.length;
        let cityTotalQuantity = 0;
        let cityTotalQuantityInKg = 0;
        let cityTotal = 0;
        let cityTotalWithKG = 0;
        city.site_wise_details.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteTotalQuantityInKg = 0;
          let siteMaterialTotalAmount = 0;
          let siteMaterialTotalAmountWithKG = 0;

          const groupedData = {};
          site.material_wise_details.forEach((material) => {
            const rfqId = material.purchase_requisition_material_id || null;
            const rfqActualId = material.rfq_material_id || null;
            console.log("materialw", material);

            rfqPresent = material.rfq_material_id;

            if (!groupedData[rfqId]) {
              groupedData[rfqId] = {
                rfq_material_id: rfqId,
                site_id: site.site_id,
                rfqActualId: rfqActualId,
                site_name: site.site_name,
                material_type_names: new Set([material.material_type_name]),
                material_type_sub_category: material.material_type_sub_category,
                pr_total_quantity: material.pr_total_quantity,
                pr_total_quantity_by_kg: material.pr_total_quantity_by_kg,
                estimated_material_unit_price:
                  material.estimated_material_unit_price,
                pr_total_amount: material.pr_total_amount,
                material_type_uom: material.material_type_uom,
                material_type_uom_name:
                  material.preferred_unit_of_measurement ||
                  material.material_type_uom_name,
                preferred_unit_of_measurement:
                  material.preferred_unit_of_measurement,
                preferred_unit_of_measurement_id:
                  material.preferred_unit_of_measurement_id,
                purchase_requisition_material_id:
                  material.purchase_requisition_material_id,
              };
            } else {
              groupedData[rfqId].material_type_names.add(
                material.material_type_name,
              );
              groupedData[rfqId].pr_total_quantity +=
                material.pr_total_quantity;
              groupedData[rfqId].pr_total_amount += material.pr_total_amount;
            }
          });

          const result = Object.values(groupedData).map((item) => ({
            ...item,
            material_type_names: Array.from(item.material_type_names).join(
              ", ",
            ),
          }));

          const materialGroups = site.material_wise_details.reduce(
            (acc, material, index) => {
              if (material.purchase_requisition_master_id) {
                uniqueMasterIds.add(material.purchase_requisition_master_id);
              }
              console.log("materialss", material);

              const {
                material_type_name,
                material_type_uom_name,
                preferred_unit_of_measurement,
                pr_total_quantity,
                pr_total_quantity_by_kg,
                estimated_material_unit_price,
                pr_total_amount,
                purchase_requisition_master_id,
                actual_quantity,
                rfq_material_id,
                purchase_requisition_material_id,
                preferred_unit_of_measurement_id,
                material_type_uom,
                remark,
                vendors,
                material_type_sub_category,
              } = material;

              if (!acc[material_type_name]) {
                acc[material_type_name] = {
                  material_type_name,
                  preferred_unit_of_measurement,
                  material_type_uom_name:
                    preferred_unit_of_measurement || material_type_uom_name,
                  total_quantity: 0,
                  actual_quantity: 0,
                  total_quantity_by_kg: 0,
                  total_amount: 0,
                  estimated_material_unit_price,
                  purchase_requisition_master_ids: new Set(),
                  rfq_material_id,
                  purchase_requisition_material_id,
                  preferred_unit_of_measurement_id,
                  material_type_uom,
                  remark,
                  vendors,
                  siteIndex,
                  cityIndex,
                  index,
                  material_type_sub_category,
                };
              }

              const currentSiteName = site.site_name;
              const currentMaterialTypeName = material_type_name;
              const uniqueMasterIdss =
                uniqueMasterIdsBySiteAndMaterial[currentSiteName]?.[
                  currentMaterialTypeName
                ] || [];

              const conversionForSand = city.sand_conversion || 1.6;

              let convertedQuantity = pr_total_quantity;
              let convertedQuantityInKg = pr_total_quantity_by_kg;
              let finalUOM =
                preferred_unit_of_measurement || material_type_uom_name;

              if (uniqueMasterIdss.size > 1 && rfq_material_id === null) {
                if (material_type_name.includes("Sand")) {
                  if (preferred_unit_of_measurement === "MT") {
                    convertedQuantity = pr_total_quantity_by_kg / 1000;
                  } else if (preferred_unit_of_measurement === "Cum.") {
                    convertedQuantity =
                      pr_total_quantity_by_kg / (conversionForSand * 1000); 
                  } else if (preferred_unit_of_measurement === "KG") {
                    convertedQuantity = pr_total_quantity_by_kg;
                  } else if (preferred_unit_of_measurement === "Bag") {
                    convertedQuantity = pr_total_quantity_by_kg / 50;
                  }
                } else {
                  if (preferred_unit_of_measurement === "MT") {
                    convertedQuantity = pr_total_quantity_by_kg / 1000;
                  } else if (preferred_unit_of_measurement === "Cum.") {
                    convertedQuantity = pr_total_quantity_by_kg / 1600;
                  } else if (preferred_unit_of_measurement === "KG") {
                    convertedQuantity = pr_total_quantity_by_kg;
                  } else if (preferred_unit_of_measurement === "Bag") {
                    convertedQuantity = pr_total_quantity_by_kg / 50;
                  }
                }
                finalUOM =
                  preferred_unit_of_measurement || material_type_uom_name;
              } else {
                if (material_type_name.includes("Sand")) {
                  if (preferred_unit_of_measurement === "MT") {
                    convertedQuantity = pr_total_quantity_by_kg / 1000;
                  } else if (preferred_unit_of_measurement === "Cum.") {
                    convertedQuantity =
                      pr_total_quantity_by_kg / (conversionForSand * 1000); 
                  } else if (preferred_unit_of_measurement === "KG") {
                    convertedQuantity = pr_total_quantity_by_kg;
                  } else if (preferred_unit_of_measurement === "Bag") {
                    convertedQuantity = pr_total_quantity_by_kg / 50;
                  }
                } else {
                  convertedQuantity = pr_total_quantity;
                  convertedQuantityInKg = pr_total_quantity_by_kg;
                  finalUOM =
                    material_type_uom_name || preferred_unit_of_measurement;
                }
              }

              acc[material_type_name].total_quantity += convertedQuantity;
              acc[material_type_name].actual_quantity += convertedQuantity;
              acc[material_type_name].total_quantity_by_kg +=
                convertedQuantityInKg;
              acc[material_type_name].total_amount += pr_total_amount;
              acc[material_type_name].material_type_uom_name = finalUOM;
              acc[material_type_name].preferred_unit_of_measurement = finalUOM;

              const uomOption = uomList.find(
                (option) => option.unit_of_measurement === finalUOM,
              );
              acc[material_type_name].material_type_uom = uomOption
                ? uomOption.id
                : material_type_uom;
              acc[material_type_name].preferred_unit_of_measurement_id =
                uomOption ? uomOption.id : material_type_uom;

              if (purchase_requisition_master_id) {
                acc[material_type_name].purchase_requisition_master_ids.add(
                  purchase_requisition_master_id,
                );
              }

              return acc;
            },
            {},
          );

          let groupedMaterials = Object.values(materialGroups).map(
            (material) => {
              let unitMeasurement = material.preferred_unit_of_measurement;
              let unitMeasurementId = material.preferred_unit_of_measurement_id;

              if (
                Array.from(material.purchase_requisition_master_ids).length >
                  1 &&
                material.rfq_material_id === null
              ) {
                const uomOption = memoizedPincodeList.find(
                  (option) =>
                    option.unit_of_measurement ===
                    material.preferred_unit_of_measurement,
                );
                unitMeasurement = material.preferred_unit_of_measurement;
                unitMeasurementId = uomOption
                  ? uomOption.id
                  : material.material_type_uom;
              } else {
                unitMeasurement = material.material_type_uom_name;
                unitMeasurementId = material.material_type_uom;
              }

              return {
                ...material,
                material_type_uom: unitMeasurementId,
                material_type_uom_name: unitMeasurement,
                purchase_requisition_master_ids: Array.from(
                  material.purchase_requisition_master_ids,
                ),
              };
            },
          );

          groupedMaterials.forEach((material) => {
            siteTotalQuantity += material.total_quantity;
            siteMaterialTotalAmount += material.total_amount;
            siteTotalQuantityInKg += material.total_quantity_by_kg;

            if (material.material_type_sub_category === "RMC") {
              siteMaterialTotalAmountWithKG +=
                material.total_quantity *
                material.estimated_material_unit_price;
            } else {
              siteMaterialTotalAmountWithKG +=
                material.total_quantity_by_kg *
                material.estimated_material_unit_price;
            }
          });

          site.site_total_quantity = siteTotalQuantity;
          cityTotalQuantity += siteTotalQuantity;
          cityTotalQuantityInKg += siteTotalQuantityInKg;
          cityTotal += siteMaterialTotalAmount;
          cityTotalWithKG += siteMaterialTotalAmountWithKG;

          tableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : "",
            cityName1: city.city_name,
            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.site_name,
            siteName1: site.site_name,
            siteData: result,
            siteLocations: groupedMaterials.map((material, ind) => {
              return {
                vendors: material?.vendors,
                cityName: city.city_name,
                cityIndex: material.cityIndex,
                siteIndex: material.cityIndex,
                siteId: site.site_name,
                matInd: ind,
                materialName: material.material_type_name,
                quantity: material.total_quantity.toFixed(3),
                actual_quantity: material.actual_quantity,
                quantity_by_kg: material.total_quantity_by_kg.toLocaleString(
                  "en-IN",
                  {
                    maximumFractionDigits: 0,
                  },
                ),
                remark: material.remark,
                uom: material.preferred_unit_of_measurement,
                uom_pref: material.preferred_unit_of_measurement_id,
                subCategory: material.material_type_sub_category,
                estimatedPrice: material.estimated_material_unit_price,
                materialTotal: material.total_amount,
                unit_measurement: material.material_type_uom,
                unit_measurement_id: material.material_type_uom,
                unit_measurement_name: material.material_type_uom_name,
                purchase_master_ids: [
                  ...material.purchase_requisition_master_ids,
                ],
                purchase_requisition_material_id:
                  material.purchase_requisition_material_id,
                rfq_material_idd: material.rfq_material_id,
                sand_conversion: city.sand_conversion,
                aggregate_conversion: city.aggregate_conversion,
              };
            }),
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                className="site-subtotal"
              />
            ),
          });

          tableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: "Site Sub-Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotalAmountWithKG,
                materialName: "",
                quantity: "",
                quantity_by_kg: "",
                subCategory: "",
                siteIndex,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={
                  siteTotalQuantity?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || 0
                }
                className="site-total-quantity"
                readOnly
              />
            ),
          });

          if (length > 1 && siteIndex === city.site_wise_details.length - 1) {
            tableData.push({
              key: `${prIndex}-${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotalWithKG,
                  quantity: "",
                  quantity_by_kg: "",
                  subCategory: "",
                  siteIndex,
                  cityId: city.city_id,
                  siteId: site.site_id,
                },
              ],
              totalAmount: cityTotal,
              cityTotalQuantity: (
                <Input
                  disabled
                  value={cityTotalQuantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        });

        city.city_total_quantity = cityTotal;
      });
    });
    console.log("tassbleData", tableData);

    setTableData(tableData);
    setapiLoading(false);
  };
  const updateWbsData = (state) => {
    const tableData = [];
    const length = state[0]?.city_wise_pr?.length;
    setCityLength(length);

    state?.forEach((prObject, prIndex) => {
      prObject?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city?.site_wise_details?.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          let siteMaterialTotalAmount = 0;
          let newSites = 0;

          site?.material_wise_details?.forEach((material) => {
            siteTotalQuantity += material?.pr_total_quantity;

            siteMaterialTotalAmount += material?.pr_total_amount;

            siteMaterialTotal +=
              material?.pr_total_quantity *
              material?.estimated_material_unit_price;
          });

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotalAmount;

          tableData.push({
            prNumber: prObject.pr,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${prObject.pr}-${prIndex}-${cityIndex}-${siteIndex}`,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map(
              (material, matIndex) => ({
                materialTotal: material.pr_total_amount,
                availableBudget: material.available_budget || 0,
                estimatedPRValue: newSites || 0,
                materialName: material.material_type_name,
                quantity: material.material_type_quantity,
                uom: material.material_type_uom,
                subCategory: material.material_type_sub_category,
                siteIndex,
                matIndex,
                siteId: site.site_id,
                estimatedPrice: material.estimated_material_unit_price,
              }),
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            prNumber: prObject.pr,
            key: `${prObject.pr}-${prIndex}-${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }
      });
    });

    setStateWBS(tableData);
  };
  useEffect(() => {
    setapiLoading(true);
    if (response.pr_city_wise_by_pr_number !== null) {
      setRes(response);
      updateTableData(response?.pr_city_wise_by_pr_number);
      updateWbsData(response?.pr_city_wise_by_pr_number);

      setRfqIDD(response?.rfq_details[0]?.id);
    }
    console.log("reddsponse", response);

    setSelectedCategoryName(response.category_tree_name);
    if (
      Array.isArray(response?.rfq_material_details) &&
      response?.rfq_material_details.length === 0
    ) {
      setRfqMaterialDetailsID(false);
    } else {
      setRfqMaterialDetailsID(true);
    }
    setapiLoading(false);
  }, [response, res]);

  const getSiteName = async () => {
    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`,
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      //setLoading(false);
    }
  };

  const handleUOMChange = (
    value,
    cityName,
    siteName,
    matIndex,
    unitOfMeasurement,
    newQuantity,
  ) => {
    setTableData((prevState) => {
      const newState = prevState.map((row) => {
        if (row.cityName1 === cityName && row.siteName1 === siteName) {
          const updatedRow = { ...row };

          if (updatedRow.siteLocations && updatedRow.siteLocations[matIndex]) {
            const updatedMaterial = { ...updatedRow.siteLocations[matIndex] };

            updatedMaterial.uom = value;
            updatedMaterial.unit_measurement = value;
            updatedMaterial.uom_pref = value;
            updatedMaterial.unit_measurement_name = unitOfMeasurement;

            let adjustedQuantity = parseFloat(updatedMaterial.quantity || 0);

            if (unitOfMeasurement === "Bag") {
              adjustedQuantity *= 20;
            } else if (unitOfMeasurement === "MT") {
              adjustedQuantity *= 0.05;
            } else if (unitOfMeasurement === "KG") {
              adjustedQuantity *= 1000;
            }

            updatedMaterial.quantity = adjustedQuantity;

            updatedRow.siteLocations[matIndex] = updatedMaterial;

            if (updatedRow.siteData && updatedRow.siteData[matIndex]) {
              const updatedSiteDataMaterial = {
                ...updatedRow.siteData[matIndex],
                material_type_uom_name: unitOfMeasurement,
                unit_measurement: value,
                uom_pref: value,
                pr_total_quantity:
                  updatedRow.siteData[matIndex].material_type_uom_name !==
                  updatedMaterial.unit_measurement
                    ? unitOfMeasurement === "MT"
                      ? parseInt(
                          updatedRow.siteData[matIndex].pr_total_quantity_by_kg,
                        ) / 1000
                      : parseInt(
                          updatedRow.siteData[matIndex].pr_total_quantity_by_kg,
                        ) / 50
                    : adjustedQuantity,
              };
              updatedRow.siteData[matIndex] = updatedSiteDataMaterial;
            }
          }

          return updatedRow;
        }

        if (row.siteName === "Site Sub-Total" && row.cityName === cityName) {
          const updatedRow = { ...row };

          const siteTotalQuantity = newState
            .filter((r) => r.cityName === cityName && r.siteName === siteName)
            .reduce((total, r) => {
              r.siteLocations?.forEach((loc) => {
                total += parseFloat(loc.quantity || 0);
              });
              return total;
            }, 0);

          const siteTotalAmount = newState
            .filter((r) => r.cityName === cityName && r.siteName === siteName)
            .reduce((total, r) => {
              r.siteLocations?.forEach((loc) => {
                total += parseFloat(loc.materialTotal || 0);
              });
              return total;
            }, 0);

          if (updatedRow.siteLocations?.[0]) {
            updatedRow.siteLocations[0].quantity =
              siteTotalQuantity?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              });
          }
          updatedRow.totalAmount = `\u20B9 ${siteTotalAmount || 0}`;

          return updatedRow;
        }

        return row;
      });

      return newState;
    });
  };

  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 200,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      align: "right",
      width: 200,
      render: (siteLocations, record) => {
        let totalAvail = 10000000;
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100px",
                }}
              >
                ₹{" "}
                {totalAvail?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {siteLocations[0].cityTotal?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        } else {
          let total = siteLocations.reduce(
            (acc, site) => acc + site.materialTotal,
            0,
          );

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {total
                  ? total?.toLocaleString("en-IN", { maximumFractionDigits: 0 })
                  : 0}
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }
  const parseEarthingStrip = (name) => {
    const match = name.match(/(\d+)\s*x\s*(\d+)\s*[-–]\s*(\w+)/i);
    if (!match) return null;
    return {
      width: parseFloat(match[1]),
      thickness: parseFloat(match[2]),
      material: match[3].toUpperCase(), // CU or GI
    };
  };


  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 130,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return {
            children: <div className="subtotal">Sub Total</div>,
          };
        } else if (record.siteName === "City Total") {
          return {
            children: <div className="citytotal">{record.siteName}</div>,
          };
        } else {
          return <div>{record.siteName}</div>;
        }
      },
    },

    {
      title:
        selectedCategoryName === "Earthing" ? (
          <span style={{ textTransform: "none" }}>Item (mm x mm)</span>
        ) : (
          "Item"
        ),
      dataIndex: "siteLocations",
      width:  selectedCategoryName === "Earthing" ? 280 : 200,
      render: (siteLocations) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          {siteLocations.map((site, index) => (
            <div key={index} className="lblvalue">
              {site.materialName}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Qty.",
      dataIndex: "siteLocations",
      width: 80,
      // align: "center",
      render: (siteLocations, record) => {
        const renderInput = (site, index) => {
          const quantity = parseFloat(site.quantity);

          return (
            <div
              key={index}
              className="lblvalue"
              style={{ display: "flex", justifyContent: "left" }}
            >
              {isNaN(quantity) ? "" : quantity?.toFixed(2)}{" "}
            </div>
          );
        };

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
            }}
          >
            {siteLocations.map(renderInput)}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          UoM.
        </Tooltip>
      ),
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }

        if (
          siteLocations &&
          siteLocations.length > 0 &&
          siteLocations.materialName !== ""
        ) {
          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                let defaultValue = null;
                let defaultName = null;
                if (
                  site.purchase_master_ids &&
                  Object.keys(site.purchase_master_ids).length > 1 &&
                  site.rfq_material_idd === null
                ) {
                  const defaultOption =
                    pincodeList.length > 0 &&
                    pincodeList.find((option) => option.id === site.uom_pref);
                  defaultName = site.uom;
                  defaultValue = defaultOption ? defaultOption.id : 1;
                } else if (
                  site.purchase_master_ids &&
                  Object.keys(site.purchase_master_ids).length > 1
                ) {
                  const defaultOption =
                    pincodeList.length > 0 &&
                    pincodeList.find(
                      (option) => option.id === site.unit_measurement,
                    );

                  defaultValue = defaultOption ? defaultOption.id : 1;
                  defaultName = site.unit_measurement_name;
                } else {
                  defaultValue = site.unit_measurement;
                  defaultName = site.unit_measurement_name;
                }
                const currentUoM = site.uom;
                const preferredUoM = site.unit_measurement;
                let adjustedQuantity = site.quantity;

                if (currentUoM !== preferredUoM) {
                  if (currentUoM === "MT" && preferredUoM === "KG") {
                    adjustedQuantity = site.quantity * 1000;
                  } else if (currentUoM === "Bag" && preferredUoM === "KG") {
                    adjustedQuantity = site.quantity * 50;
                  } else if (currentUoM === "Bag" && preferredUoM === "MT") {
                    adjustedQuantity = (site.quantity * 50) / 1000;
                  } else if (currentUoM === "KG" && preferredUoM === "MT") {
                    adjustedQuantity = site.quantity / 1000;
                  }
                }
                if (defaultName === "Cubic Meter") {
                  return (
                    <div key={index}>
                      <Select
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        suffixIcon={null}
                        open={false}
                      >
                        {pincodeList.map((option) => (
                          <Option
                            key={option.id}
                            value={option.id}
                            style={{ paddingRight: "0px" }}
                          >
                            <span
                              style={{
                                color: "black",
                                fontSize: "12px",
                                paddingRight: "0px",
                                // fontWeight: "bold",
                              }}
                            >
                              {option.id === 4
                                ? "Cu. Mtr."
                                : option.unit_of_measurement}
                            </span>
                          </Option>
                        ))}
                      </Select>
                    </div>
                  );
                } else {
                  return (
                    <div key={index}>
                      <Select
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        disabled={defaultName === "Cubic Meter"}
                        suffixIcon={null}
                        open={false}
                        onChange={(value) => {
                          const selectedOption = pincodeList.find(
                            (option) => option.id === value,
                          );

                          handleUOMChange(
                            value,
                            site.cityName,
                            site.siteId,
                            site.matInd,
                            selectedOption
                              ? selectedOption.unit_of_measurement
                              : null,
                            adjustedQuantity,
                          );
                        }}
                      >
                        {pincodeList
                          .filter(
                            (i) => i.unit_of_measurement !== "Cubic Meter",
                          )
                          .map((option) => (
                            <Option key={option.id} value={option.id}>
                              {option.unit_of_measurement}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  );
                }
              })}
            </div>
          );
        }

        return null;
      },
    },

    !selectedCategoryName === "Earthing" && {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      align: "right",
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
            }}
          >
            {siteLocations.map((site, index) => {
              return (
                <div
                  key={index}
                  className="lblvalue"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {site.quantity_by_kg?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || ""}
                </div>
              );
            })}
          </div>
        );
      },
    },
    selectedCategoryName === "Earthing" && {
      title: (
        <Tooltip
          title="Reference price of estimated unit rate comes from material master data"
          color="#094E8F"
          placement="top"
        >
          <span>Est. Unit rate</span>
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 140,
      align: "right",
      render: (siteLocations, record) => {
        if (
          record.siteName !== "Site Sub-Total" &&
          record.siteName !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                  alignItems: "flex-end",
                  width: "110px",
                }}
              >
                {siteLocations.map((site, index) => {
                  const isEarthing = site.subCategory
                    ?.toLowerCase()
                    .includes("earthing");

                  if (isEarthing) {
                    const parsed = parseEarthingStrip(site.materialName);
                    if (parsed) {
                      const kgPerMeter = getKgPerMeter(
                        parsed.width,
                        parsed.thickness,
                        parsed.material,
                      );
                      const ratePerKg =
                        site.estimated_price || site.estimatedPrice || 0;
                      const ratePerMeter = kgPerMeter * ratePerKg;

                      const supplierProfitPercent = 10;
                      const res =
                        ratePerMeter * (1 + supplierProfitPercent / 100);

                      return (
                        <div
                          key={index}
                          style={{ fontWeight: 500, color: "#d4380d" }}
                        >
                          ₹{" "}
                          {res?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}{" "}
                          / m
                        </div>
                      );
                    }
                  }
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      ₹ {site.estimatedPrice}{" "}
                      {site.subCategory === "RMC"
                        ? "/ Cu.M."
                        : site.materialName.includes("Aggregate") ||
                            site.materialName.includes("Dust")
                          ? "/ MT"
                          : "/ Kg"}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    selectedCategoryName !== "Earthing" && {
      title: "Est. Amount",
      dataIndex: "siteLocations",
      align: "right",
      width: 140,
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
              alignItems: "flex-end",
            }}
          >
            {siteLocations.map((site, index) => {
              let total = 0;

              if (site?.unit_measurement_name === "Cubic Meter") {
                total =
                  site?.unit_measurement_name === "Cubic Meter"
                    ? Number(site?.quantity) * site?.estimatedPrice
                    : site?.materialTotal;
              } else {
                total =
                  Number(site?.quantity_by_kg.replace(/,/g, "")) *
                  site?.estimatedPrice;
              }

              if (site.materialName !== "") {
                return (
                  <div
                    key={index}
                    className="lblvalue "
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              } else if (record.siteName === "Site Sub-Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue subtotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <span>
                      {`₹ ${site?.totalQuantity.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </span>
                  </div>
                );
              } else if (record.siteName === "City Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue citytotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <span>
                      {`₹ ${site.cityTotal.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </span>
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    className="lblvalue"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {site?.totalQuantity?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              }
            })}
          </div>
        );
      },
    },
    selectedCategoryName === "Earthing" && {
          title: "Est. Amount",
          width: 170,
          align: "right",
          render: (_, record) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                alignItems: "flex-end",
              }}
            >
              {record.siteLocations.map((site, idx) => {
                console.log("site in amount column", site);
                // Handle subtotal / total rows
                if (!site.materialName) {
                  if (record.siteName1 === "Site Sub Total") {
                    return (
                      <div key={`subtotal-site-${record.key}`} className="subtotal">
                        ₹ {site.totalAmountByKG?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  if (record.siteName1 === "City Total") {
                    return (
                      <div key={`citytotal-${record.key}`} className="citytotal">
                        ₹ {site.cityTotalAmountForKG?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  if (record.siteName1 === "Total") {
                    console.log(
                      "site.totalCityOverallSite",
                      site.totalCityOverallSite
                    );
                    return (
                      <div
                        key="grandtotal"
                        className="totalCityOverallSitee5"
                        style={{ fontWeight: "bold" }}
                      >
                        ₹ {site.totalCityOverallSite?.toLocaleString("en-IN") || 0}
                      </div>
                    );
                  }
                  return <div key={`empty-${idx}`} />;
                }
    
                let amount = 0;
    
                // -------------------------------------------------------
                // 🟩 EARTHING ITEMS CALCULATION (corrected!)
                // -------------------------------------------------------
                if (site.subCategory?.toLowerCase().includes("earthing")) {
                  const profitPercent = 10;
                  console.log("site.materialName", site);
                  const parsed = parseEarthingStrip(site.materialName);
                  if (parsed) {
                    const kgPerMeter = getKgPerMeter(
                      parsed.width,
                      parsed.thickness,
                      parsed.material
                    );
    
                    const ratePerKg = site.estimatedPrice || 0;
    
                    // Step 1: base rate per meter
                    const ratePerMeter = kgPerMeter * ratePerKg;
    
                    // Step 2: include supplier profit
                    const finalRatePerMeter =
                      ratePerMeter * (1 + profitPercent / 100);
    
                    // Step 3: amount = meter qty × final rate
                    amount =
                      (site.quantity || 0) *
                      finalRatePerMeter.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      });
                    console.log("amdddount", amount);
                  }
                } else {
                  let totalKg = 0;
    
                  if (site.material_type_uom_name === "MT") {
                    totalKg = (site.quantity || 0) * 1000;
                  } else if (site.material_type_uom_name === "Bag") {
                    totalKg = (site.quantity || 0) * 50;
                  } else {
                    totalKg = site.quantity || 0;
                  }
    
                  amount = totalKg * (site.estimated_price || 0);
                }
                return (
                  <div key={`amount-${record.key}-${idx}`}>
                    ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
                  </div>
                );
              })}
            </div>
          ),
        },
    {
      title: (
        <Tooltip color="#094E8F" placement="top">
          <span style={{ textTransform: "none" }}>{t("bidders")}</span>
        </Tooltip>
      ),
      width: 280,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }

        if (
          siteLocations &&
          siteLocations.length > 0 &&
          siteLocations.materialName !== ""
        ) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "11px",
              }}
            >
              {siteLocations.map((site, index) => {
                return (
                  <div key={index} style={{ whiteSpace: "normal" }}>
                    <Select
                      mode="multiple"
                      maxTagCount="responsive"
                      style={{ width: "100%" }}
                      placeholder="Please select"
                      // disabled
                      value={
                        site?.vendors
                          ?.filter((vendor) => vendor.is_selected_vendor)
                          ?.map((vendor) => vendor.name) || []
                      }
                      filterOption={(input, option) =>
                        (option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      tagRender={({ label }) => (
                        <span
                          style={{
                            padding: "4px 5px",
                            background: "#f0f0f0",
                            borderRadius: "4px",
                            marginRight: "5px",
                            cursor: "pointer",
                          }}
                        >
                          {label}
                        </span>
                      )}
                    >
                      {site?.vendors
                        ?.filter((vendor) => vendor?.is_selected_vendor)
                        ?.map((vendor) => (
                          <Select.Option
                            key={vendor?.name}
                            value={vendor?.name}
                          >
                            {vendor?.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </div>
                );
              })}
            </div>
          );
        }

        return null;
      },
    },
    {
      title: "Remark",
      dataIndex: "siteLocations",
      width: 280,
      render: (siteLocations, record) => {
        if (
          record.siteName !== "City Total" ||
          record.siteName !== "Site Sub-Total"
        ) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                marginRight: "40px",
              }}
            >
              {siteLocations.map((site, index) => {
                return (
                  <div key={index} className="lblvalue">
                    {site.remark || ""}
                  </div>
                );
              })}
            </div>
          );
        }
      },
    },
  ].filter(Boolean);

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  return (
    <>
      {
        <>
          {response?.pr_city_wise_by_pr_number?.map((prObject, prIndex) => (
            <>
              <Collapse
                key={prIndex.toString()}
                defaultActiveKey={["0"]}
                className="scroll5"
              >
                <Panel header={<Table columns={columns} />} key={prIndex}>
                  <Table
                    columns={columns}
                    dataSource={tableData.filter((row) =>
                      row.key.startsWith(`${prIndex}`),
                    )}
                    pagination={false}
                    rowKey="key"
                  />
                </Panel>
              </Collapse>
            </>
          ))}
        </>
      }
    </>
  );
};

ViewNewPR.propTypes = {
  response: PropTypes.func,
  uomList: PropTypes.func,
};

export default ViewNewPR;
